// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectItemsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectItemsQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Region', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Market', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Community', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Subdivision', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Lot', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Structure', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined } | { __typename?: 'Unit', id: string, activeProjectStage?: { __typename?: 'ProjectStage', id: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } }> } | null | undefined }, items: Array<{ __typename?: 'Item', id: string, name: string }> };

export type SaveProjectItemMutationVariables = Types.Exact<{
  input: Types.ProjectItemInput;
}>;


export type SaveProjectItemMutation = { __typename?: 'Mutation', saveProjectItems: { __typename?: 'SaveProjectItemsResult', projectItems?: Array<{ __typename?: 'ProjectItem', id: string }> | null | undefined, userErrors?: Array<{ __typename?: 'UserError', message: string }> | null | undefined } };

export type ProjectItemsItemFragment = { __typename?: 'ProjectItem', id: string, name: string, description?: string | null | undefined, quantity?: number | null | undefined, unitPriceInCents: number, unitCostInCents: number, item: { __typename?: 'Item', id: string, name: string } };

export const ProjectItemsItemFragmentDoc = gql`
    fragment ProjectItemsItem on ProjectItem {
  id
  item {
    id
    name
  }
  name
  description
  quantity
  unitPriceInCents
  unitCostInCents
}
    `;
export const ProjectItemsDocument = gql`
    query ProjectItems($projectId: ID!) {
  project(id: $projectId) {
    id
    activeProjectStage {
      id
      projectItems {
        ...ProjectItemsItem
      }
    }
  }
  items(filter: {status: [ACTIVE]}) {
    id
    name
  }
}
    ${ProjectItemsItemFragmentDoc}`;

/**
 * __useProjectItemsQuery__
 *
 * To run a query within a React component, call `useProjectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectItemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectItemsQuery, ProjectItemsQueryVariables> & ({ variables: ProjectItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectItemsQuery, ProjectItemsQueryVariables>(ProjectItemsDocument, options);
      }
export function useProjectItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectItemsQuery, ProjectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectItemsQuery, ProjectItemsQueryVariables>(ProjectItemsDocument, options);
        }
// @ts-ignore
export function useProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemsQuery, ProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemsQuery, ProjectItemsQueryVariables>;
export function useProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemsQuery, ProjectItemsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemsQuery | undefined, ProjectItemsQueryVariables>;
export function useProjectItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemsQuery, ProjectItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectItemsQuery, ProjectItemsQueryVariables>(ProjectItemsDocument, options);
        }
export type ProjectItemsQueryHookResult = ReturnType<typeof useProjectItemsQuery>;
export type ProjectItemsLazyQueryHookResult = ReturnType<typeof useProjectItemsLazyQuery>;
export type ProjectItemsSuspenseQueryHookResult = ReturnType<typeof useProjectItemsSuspenseQuery>;
export type ProjectItemsQueryResult = Apollo.QueryResult<ProjectItemsQuery, ProjectItemsQueryVariables>;
export const SaveProjectItemDocument = gql`
    mutation SaveProjectItem($input: ProjectItemInput!) {
  saveProjectItems(input: {projectItems: [$input]}) {
    projectItems {
      id
    }
    userErrors {
      message
    }
  }
}
    `;
export type SaveProjectItemMutationFn = Apollo.MutationFunction<SaveProjectItemMutation, SaveProjectItemMutationVariables>;

/**
 * __useSaveProjectItemMutation__
 *
 * To run a mutation, you first call `useSaveProjectItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectItemMutation, { data, loading, error }] = useSaveProjectItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectItemMutation, SaveProjectItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectItemMutation, SaveProjectItemMutationVariables>(SaveProjectItemDocument, options);
      }
export type SaveProjectItemMutationHookResult = ReturnType<typeof useSaveProjectItemMutation>;
export type SaveProjectItemMutationResult = Apollo.MutationResult<SaveProjectItemMutation>;
export type SaveProjectItemMutationOptions = Apollo.BaseMutationOptions<SaveProjectItemMutation, SaveProjectItemMutationVariables>;